import type { FC } from 'react';

import { Chip, typographyVariants } from '@mint-lib/tw-components';

import type { ApproverEntity } from '../../../types/shared.js';

type Props = {
  approvers: ApproverEntity[];
};

const ApproversSection: FC<Props> = ({ approvers }) => {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {approvers.map((entity, index) => {
        return entity.type === 'operation' ? (
          <span
            key={entity.id + index}
            className={typographyVariants({
              variant: 'bodyShort01',
              color: 'secondary',
            })}
          >
            {entity.label.toUpperCase()}
          </span>
        ) : (
          <Chip
            key={entity.id + index}
            variant="outline"
            size="medium"
            color="silver"
          >
            {entity.label}
          </Chip>
        );
      })}
    </div>
  );
};

export default ApproversSection;
